export default (function (onSuccess) {
  if (window.AppleID && window.AppleID.auth) {
    window.AppleID.auth.signIn().then(function (_ref) {
      var authorization = _ref.authorization,
          user = _ref.user;
      onSuccess(authorization, user);
    });
  }
});